var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 22036"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17731",
    d: "M4 4.9a1.954 1.954 0 0 0-2 1.9v7.619a1.954 1.954 0 0 0 2 1.9h12a1.954 1.954 0 0 0 2-1.9V6.81a1.954 1.954 0 0 0-2-1.9h-1.586a1.026 1.026 0 0 1-.707-.279l-1.121-1.073A2.052 2.052 0 0 0 11.172 3H8.828a2.052 2.052 0 0 0-1.414.558L6.293 4.626a1.026 1.026 0 0 1-.707.279zm6 8.571a2.931 2.931 0 0 0 3-2.857 2.931 2.931 0 0 0-3-2.857 2.931 2.931 0 0 0-3 2.857 2.931 2.931 0 0 0 3 2.857z",
    transform: "translate(2 2)",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20031",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.485a9a6c5dc100dc59f4b6f0651c27af.svg";
export { ForwardRef as ReactComponent };